const equalHeightElements = document.querySelectorAll('.equal-height .wp-block-group');

function equalizeHeight() {
	let maxHeight = 0;

	// Get Max Height
	for (const item of equalHeightElements) {
		const child = item.firstElementChild;
		if (child.offsetHeight > maxHeight) {
			maxHeight = child.offsetHeight;
		}
	}

	// Set the same height for all.
	for (const item of equalHeightElements) {
		// Set only if columns.
		if (window.innerWidth > 781) {
			item.style.height = maxHeight + 'px';
		} else {
			item.style.height = '';
		}
	}
}

window.addEventListener('DOMContentLoaded', equalizeHeight);
window.addEventListener('resize', equalizeHeight);
